<template>
  <div>
    <div class="container-menu-normal">
      <div class="menu-normal">
        <a href="/home">
          <img :src="logoUrl" alt="Logo" class="logo-menu-normal" />
        </a>

        <a
          class="menu-option-normal"
          href="/home"
          :style="{ color: textColor }"
        >
          Inicio
        </a>

        <a
          class="menu-option-normal"
          href="/social-networks"
          :style="{ color: textColor }"
        >
          Contenido redes
        </a>

        <a
          class="menu-option-normal"
          href="/product"
          :style="{ color: textColor }"
        >
          Producto
        </a>

        <a
          class="menu-option-normal"
          href="/fashion"
          :style="{ color: textColor }"
        >
          Moda
        </a>

        <a
          class="menu-option-normal"
          href="/corporate"
          :style="{ color: textColor }"
        >
          Empresarial
        </a>

        <a
          class="menu-option-normal"
          href="/other-services"
          :style="{ color: textColor }"
        >
          Otros servicios
        </a>
      </div>
    </div>

    <div class="container-menu-hamburger">
      <div class="hamburger">
        <a href="/home">
          <img :src="logoUrl" alt="Logo" class="hamburger-logo" />
        </a>

        <img
          :src="isMenuOpen ? closeIcon : menuIcon"
          :alt="isMenuOpen ? 'Cerrar menú' : 'Abrir menú'"
          class="hamburger-icon"
          @click="toggleMenu"
        />
      </div>

      <div class="menu" :class="{ open: isMenuOpen }">
        <a
          class="menu-option"
          href="/home"
          :style="{ color: textColor }"
          @click="closeMenu"
        >
          Inicio
        </a>

        <a
          class="menu-option"
          href="/social-networks"
          :style="{ color: textColor }"
          @click="closeMenu"
        >
          Contenido redes
        </a>

        <a
          class="menu-option"
          href="/product"
          :style="{ color: textColor }"
          @click="closeMenu"
        >
          Producto
        </a>

        <a
          class="menu-option"
          href="/fashion"
          :style="{ color: textColor }"
          @click="closeMenu"
        >
          Moda
        </a>

        <a
          class="menu-option"
          href="/corporate"
          :style="{ color: textColor }"
          @click="closeMenu"
        >
          Empresarial
        </a>

        <a
          class="menu-option"
          href="/other-services"
          :style="{ color: textColor }"
          @click="closeMenu"
        >
          Otros servicios
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuComponent",

  props: {
    logoUrl: {
      type: String,
      default: "assets/logos/LogoDarkBlue.svg",
    },

    textColor: {
      type: String,
      default: "#141414",
    },

    menuIcon: {
      type: String,
      default: "assets/icons/MenuDarkBlue.svg",
    },

    closeIcon: {
      type: String,
      default: "assets/icons/CloseDarkBlue.svg",
    },
  },

  data() {
    return {
      isMenuOpen: false,
    };
  },

  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    closeMenu() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/layout/styles/menuComponentStyle";
</style>
